module.exports = __webpack_public_path__ + "static/media/9DESA7.1c007cb2.jpg";